import e from "react";
import a from "../../../../../node_modules/classnames/index.js";
function l(l) {
  var t,
    s = l.title,
    i = l.description,
    n = l.iframe,
    r = l.tags,
    c = l.sidebar,
    o = l.tagColors,
    m = l.onClick,
    d = l.small,
    _ = l.className;
  t = c ? r.filter(function (e) {
    return "Suggested" !== e;
  }) : r;
  var u = a(d ? "itc-video-small" : "itc-video", _);
  (null == i ? void 0 : i.length) >= 120 && (i = i.slice(0, 117) + "...");
  var v = s;
  return (null == v ? void 0 : v.length) >= 42 && !d && (v = v.slice(0, 39) + "..."), (null == v ? void 0 : v.length) >= 42 && d && (v = v.slice(0, 45) + "..."), e.createElement("div", {
    className: u + "__card",
    onClick: m
  }, e.createElement("div", {
    className: u + "__iframe",
    dangerouslySetInnerHTML: n
  }), e.createElement("div", {
    className: u + "__info"
  }, c && !d && e.createElement("div", {
    className: u + "__tag-box"
  }, null == t ? void 0 : t.map(function (a, l) {
    return e.createElement("span", {
      key: l,
      className: u + "__tag itc-video__tag--" + o[a]
    }, a);
  })), e.createElement("span", {
    className: u + "__title"
  }, v), e.createElement("span", {
    className: u + "__description"
  }, i)));
}
l.defaultProps = {
  small: !1
};
export { l as VideoCard };